import axios from "../../Axios/Default";
import { authUser, msAuthUser } from "../../Services/AuthService";
import Swal from "sweetalert2";

export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const UPDATE_IMAGE = "UPDATE_IMAGE";

export const logout = (navigate) => (dispatch) => {
  delete axios.defaults.headers.common["Authorization"];
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  dispatch({ type: AUTH_LOGOUT });
  localStorage.setItem("last_path", window.location.pathname);
  sessionStorage.clear();
  navigate("/login");
};

export const login =
  (navigate, payload, onError = (err) => {}) =>
  (dispatch) => {
    authUser(
      payload,
      (res) => {
        const {
          access_token,
          refresh_token,
          userid,
          username,
          fullname,
          email,
          position,
          jobtitle,
          office,
          image_name,
          access,
          role_id,
          nik,
        } = res.data;

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem("position", position);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${access_token}`;
        localStorage.removeItem("image_name");
        const userInfo = {
          userid,
          username,
          fullname,
          email,
          position,
          jobtitle,
          office,
          image_name,
          access,
          role_id,
          nik,
        };

        /*Swal.fire({
            icon: 'success',
            title: 'Succes!',
            text: 'Login succes, please wait for a while, system will be redirected to the home page',
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            }
        }).then(r => {*/
        dispatch({ type: AUTH_SUCCESS, userInfo });
        const last_path = localStorage.getItem("last_path");
        if (last_path) {
          const path = last_path
            .replace("login", "dashboard")
            .split("/")
            .slice(0, 6)
            .join("/");
          navigate(path);
          localStorage.removeItem("last_path");
        } else {
          navigate("/dashboard");
        }
        //})
      },
      onError
    );
  };

export const msLogin =
  (navigate, payload, onError = (err) => {}) =>
  (dispatch) => {
    msAuthUser(
      payload,
      (res) => {
        const {
          access_token,
          refresh_token,
          userid,
          username,
          fullname,
          position,
          email,
          jobtitle,
          office,
          image_name,
          access,
          role_id,
          nik,
        } = res.data;

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem("position", position);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${access_token}`;
        localStorage.removeItem("image_name");
        const userInfo = {
          userid,
          username,
          fullname,
          email,
          position,
          jobtitle,
          office,
          image_name,
          access,
          role_id,
          nik,
        };

        /*Swal.fire({
            icon: 'success',
            title: 'Succes!',
            text: 'Login succes, please wait for a while, system will be redirected to the home page',
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            }
        }).then(r => {*/
        dispatch({ type: AUTH_SUCCESS, userInfo });
        const last_path = localStorage.getItem("last_path");
        if (last_path) {
          const path = last_path
            .replace("login", "dashboard")
            .split("/")
            .slice(0, 6)
            .join("/");
          navigate(path);
          localStorage.removeItem("last_path");
        } else {
          navigate("/dashboard");
        }
        //})
      },
      onError
    );
  };

export const updateImage = (tempUrl) => (dispatch) => {
  dispatch({ type: UPDATE_IMAGE, tempUrl });
};
